import React, { useState, useEffect, useCallback, useRef } from "react"
import { useParams } from "react-router-dom"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn } from "lib/utils"
import ContentEditor from "lib/units/content/ContentEditor"
import useTemplate from "lib/units/template/useTemplate"
import { useStatements } from "lib/units/element/Statement"

export default function StatementContentWrapper(){

  const { tmplid } = useParams()
  const { appState } = useAppCtx()
  const { store, AppStore, refs }:any = appStore()
  const { update, saveActiveContentOnly } = AppStore

  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", { _id: tmplid })
  const saveTemplateFn = queryTools.resource.save([`template.single.${tmplid}`])

  const { templateTools } = useTemplate(_Template)
  const { statementTools } = useStatements()
  const editorContent = useRef<any>({})


  function getButtonProps(action:string){
    return {
      className: cn(
        "w-full h-6 flex justify-center items-center uppercase text-xs cursor-pointer",
        action === "pass" ? "bg-green-700/10" : action === "fail" ? "bg-red-700/10" : "",
        action === "pass" && store.metas.currentContentAction === "pass" && "bg-green-700",
        action === "fail" && store.metas.currentContentAction === "fail" && "bg-red-700"
      ),
      onClick: (e:React.MouseEvent) => {
        e.stopPropagation()
        update(`metas.currentContentAction`, action)
      }
    }
  }


  if( !store.actives.statement ) return <></>
  return (
    <div className="w-[95%] flex flex-col my-3 mx-auto">
      <div className="w-full px-[2px] h-8 flex justify-start items-center border border-solid border-slate-700">
        <div {...getButtonProps("pass")}>if condition passes</div>
        <div {...getButtonProps("fail")}>if condition fails</div>
      </div>

      { store.metas.currentContentAction !== undefined && (
        <div className="w-full">

          { store.metas.currentContentAction === "pass" && (
            <ContentEditor
              elemtype="opening_statements"
              ctype="pass"
              value={ store.actives.statement.content.pass }
              changeFn={ (value:string) => {
                update("actives.statement.content.pass", value) 
              }}
            />
          )}

          { store.metas.currentContentAction === "fail" && (
            <ContentEditor
              elemtype="opening_statements"
              ctype="pass"
              value={ store.actives.statement.content.fail }
              changeFn={ (value:string) => update("actives.statement.content.fail", value) }
            />
          )}

          <button 
            className="mt-2 w-full h-8 bg-green-700 text-neutral-200 flex justify-center items-center text-xs uppercase tracking-wide"
            onClick={() => templateTools.statement.updateContent(_Template)}
          >
            Save Content Changes
          </button>
        </div>
      )}

    </div>
  )
}